const { isEmpty, pickBy, get, forEach } = require('lodash');

const {
  nonAiActionTypes,
  nonAiCheckTypes,
  nonAiEffectTypes,
  aiActionTypes,
  aiCheckTypes,
  aiEffectTypes
} = require('./disabledNodeTypes');

/**
 *
 * @param {Node} node
 * @param {Object containing info about disabled nodes} options
 * @returns true if node should be included
 */
function isNodeEnabled(node, options) {
  if (node.name === 'Action') {
    const action = get(node, 'data.action');
    if (action) {
      if (options.isAiEnabled && nonAiActionTypes.includes(action.type)) {
        return false;
      }
      if (!options.isAiEnabled && aiActionTypes.includes(action.type)) {
        return false;
      }
    }
  }
  if (node.name === 'Effect') {
    const effect = get(node, 'data.effect');
    if (effect) {
      if (options.isAiEnabled && nonAiEffectTypes.includes(effect.type)) {
        return false;
      }
      if (!options.isAiEnabled && aiEffectTypes.includes(effect.type)) {
        return false;
      }
    }
  }
  if (node.name === 'Check') {
    let atLeastOneEnabled = false;
    forEach(node.data, (check, checkKey) => {
      if (check) {
        let isCheckEnabled = true;
        if (options.isAiEnabled && nonAiCheckTypes.includes(check.type)) {
          delete node[checkKey];
          isCheckEnabled = false;
        }
        if (!options.isAiEnabled && aiCheckTypes.includes(check.type)) {
          delete node[checkKey];
          isCheckEnabled = false;
        }
        if (isCheckEnabled) {
          atLeastOneEnabled = true;
        }
      }
    });
    return atLeastOneEnabled;
  }
  return true;
}


/**
 * Deletes a check from a check node if its disabled.
 * @param {Node} node
 * @param {Object containing info about disabled nodes} options
 */
function removeDisabledChecks(node, options) {
  if (node.name === 'Check') {
    forEach(node.data, (check, checkKey) => {
      if (check) {
        if (options.isAiEnabled && nonAiCheckTypes.includes(check.type)) {
          delete node.data[checkKey];
        }
        if (!options.isAiEnabled && aiCheckTypes.includes(check.type)) {
          delete node.data[checkKey];
        }
      }
    });
  }
}

/**
 * @param {Node} node
 * @returns true if node has one or more input or outputs
 */
function hasAtLeastOneConnection(node) {
  let hasInput = false;
  let hasOutput = false;
  for (const inputKey of Object.keys(node.inputs)) {
    const input = node.inputs[inputKey];
    hasInput = input.connections && input.connections.length;
  }
  for (const outputKey of Object.keys(node.outputs)) {
    const output = node.outputs[outputKey];
    hasOutput = output.connections && output.connections.length;
  }
  return hasInput || hasOutput
}

/**
 * Removes empty and disabled nodes, and stray connections.
 * MODIFIES cld.nodes (this is bad, but is necessary for legacy code)
 * @param {CaseLogicDescription} cld
 * @param {Object} options
 * @returns
 */
function filterEmptyAndDisabled(cld, options) {
  // Pass 1: Filter empty nodes, timers can be empty though; also filter disabled nodes
  cld.nodes = pickBy(
    cld.nodes,
    (node) => (node.name === 'Timer' || !isEmpty(node.data)) && isNodeEnabled(node, options),
  );

  // Pass 2: Remove connections that are empty (the node was removed in pass 1)
  for (const key of Object.keys(cld.nodes)) {
    const node = cld.nodes[key];
    const isInEffectChain = !!node.effectChainNodeId;

    // Pass 2a: Remove disabled checks
    removeDisabledChecks(node, options);

    // Outputs
    for (const outputKey of Object.keys(node.outputs)) {
      const output = node.outputs[outputKey];
      output.connections = output.connections.filter(connection => {
        const otherNodeId = isInEffectChain ? 10000 * connection.node + node.effectChainNodeId : connection.node;
        return cld.nodes[otherNodeId];
      });
    }
    // Inputs
    for (const inputKey of Object.keys(node.inputs)) {
      const input = node.inputs[inputKey];
      input.connections = input.connections.filter(connection => {
        const otherNodeId = isInEffectChain ? 10000 * connection.node + node.effectChainNodeId : connection.node;
        return cld.nodes[otherNodeId];
      });
    }
  }

  if (!options.keepOrphans) {
    // Pass 3: Remove nodes not connected to anything
    for (const key of Object.keys(cld.nodes)) {
      const node = cld.nodes[key];
      if (!hasAtLeastOneConnection(node)) {
        delete cld.nodes[key];
      }
    }
  }

  return cld.nodes;
}

module.exports = filterEmptyAndDisabled;